module.exports = __webpack_public_path__ + "static/img/8.9d34ec3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8.jpeg
// module id = dtRO
// module chunks = 0